import { render, staticRenderFns } from "./management.cattle.io.roletemplate.vue?vue&type=template&id=5675d3f7&scoped=true&"
import script from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js&"
export * from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js&"
import style0 from "./management.cattle.io.roletemplate.vue?vue&type=style&index=0&id=5675d3f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675d3f7",
  null
  
)

export default component.exports